import './ServicesSection.css';
import checklistImage from '../img/2d_floor_plan.avif';
import reportImage from '../img/2d_floor_plan.avif';
import communicationImage from '../img/2d_floor_plan.avif';
import safetyImage from '../img/2d_floor_plan.avif';
import materialsImage from '../img/2d_floor_plan.avif';
import qualityImage from '../img/2d_floor_plan.avif';
import { Link } from 'react-router-dom'; // Import Link

const ServicesSupervision = () => {
  const supervisionData = [
    {
      image: checklistImage,
      title: 'Daily Checklists   &  Inspections',
      description: 'Ensure all tasks are completed, documented, and inspected daily, meticulously logging details of materials, equipment, and work progress consistently.',
      link: '/daily-checklists-inspections', // Updated link
      linkText: 'View Checklists',
    },
    {
      image: reportImage,
      title: 'Progress Reports & Documentation',
      description: 'Track project milestones, identify potential delays, and document all activities. Generate detailed reports for stakeholders.',
      link: '/progress-reports-documentation', // Updated link
      linkText: 'View Reports',
    },
    {
      image: communicationImage,
      title: 'Communication & Collaboration',
      description: 'Facilitate seamless communication between team members, contractors, and clients. Use this hub for sharing updates and addressing concerns.',
      link: '/communication-collaboration', // Updated link
      linkText: 'Communication Hub',
    },
    {
      image: safetyImage,
      title: 'Safety Protocols & Compliance',
      description: 'Enforce strict safety guidelines and ensure compliance with all relevant regulations, meticulously documenting audits and providing comprehensive training for all personnel.',
      link: '/safety-protocols-compliance', // Updated link
      linkText: 'Safety Protocols',
    },
    {
      image: materialsImage,
      title: 'Material Management & Inventory',
      description: 'Track material deliveries, manage inventory, and ensure proper storage. Verify material quality and prevent wastage.',
      link: '/material-management-inventory', // Updated link
      linkText: 'Material Management',
    },
    {
      image: qualityImage,
      title: 'Quality Assurance & Control',
      description: 'Implement quality control procedures to ensure adherence to specifications, meticulously documenting inspections and testing results to verify workmanship and materials rigorously.',
      link: '/quality-assurance-control', // Updated link
      linkText: 'Quality Assurance',
    },
  ];
  
  return (
    <div>
      <div className="site-supervision">
        <h2>Site Supervision & Quality Control</h2>
        <p>Effective site supervision is crucial for project success. This section provides resources for ensuring quality, safety, and adherence to project specifications.</p>
        <div className="supervision-content">
          {supervisionData.map((item, index) => (
            <div className="supervision-item" key={index}>
              <img src={item.image} alt={item.title} className="supervision-image" loading="lazy"/>
              <h3>{item.title}</h3>
              <p>{item.description}</p>
              <Link to={item.link}>{item.linkText}</Link> {/* Use Link */}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ServicesSupervision;